import { Component, HostListener, ViewChild, ElementRef, OnInit,Renderer2 } from '@angular/core';
import { NavigationStart,NavigationEnd, ActivatedRoute, Router, RouterOutlet,Event as NavigationEvent  } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Keepalive } from '@ng-idle/keepalive';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Guid } from 'guid-typescript';
import { OAuthService } from 'angular-oauth2-oidc';
import { B2cConfigService } from './services/b2c-config.service';
import * as $ from 'jquery';
import { UserAuthService } from './services/user-auth.service';
import { Subject } from 'rxjs';
import { AppInsightsService } from './services/appinsights.service';
import { DcQuoteService } from './services/dc-quote.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgIf } from '@angular/common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { ProfileService } from '../app/services/profile.service';
import { OtpService } from './services/otp.service';
import { MfaSessionService } from './services/mfa-session.service';
declare global
{
  interface Window{
    dataLayer:any;
  }
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    host: { 'class': 'd-flex flex-column iefixfoo' },
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [
        RouterOutlet,
        NgIf,
        NgxSpinnerModule,
    ],
})
export class AppComponent implements OnInit {
  @ViewChild('logoutModel', { static: false }) logoutModel: ElementRef;
  idleState = 'Not started.';
  timedOut = false;
  lastPing: Date | null = null;
  title = 'angular-idle-timeout';
  env = environment;
  public modalOptions: NgbModalOptions;
  appInsights = new ApplicationInsights({ config: { instrumentationKey: this.env.appInsights.instrumentationKey } });
  idNumber;
  // token;
  notificationClickTrack: any;
  userActivity: any;
  shouldShowSpinner: boolean = true;
  userInactive: Subject<any> = new Subject();
  private sessionTimeoutModalRef: NgbModalRef;
  isFirstLoad = true;
  constructor(
    private readonly idle: Idle,
    private readonly keepalive: Keepalive,
    private readonly modalService: NgbModal,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly b2cConfig: B2cConfigService,
    private readonly userAuthService: UserAuthService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly renderer: Renderer2,
    private readonly dcQuoteService: DcQuoteService,
    private readonly profileService: ProfileService,
    private readonly appInsightsService: AppInsightsService,
    private readonly otpService: OtpService,
    private readonly mfaSessionService: MfaSessionService,
  ) {
    
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId', '/');
    this.cookieService.delete('isPwaActive', '/');

    this.configureAzureAd();

    // Back/forward cache can restore a signed-in page after logout or timeout; send it to login.
    globalThis.addEventListener('pageshow', (event: PageTransitionEvent) => {
      if (event.persisted
        && globalThis.location.pathname.toLowerCase().startsWith('/portal')
        && !this.userAuthService.hasValidSession()) {
        globalThis.location.replace(globalThis.location.origin + '/login');
      }
    });

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false
    };

    if (this.env.appInsights.isEnable) {
      this.appInsights=this.appInsightsService.appInsightsObj();
      if (this.cookieService.get('userData') != null && this.cookieService.get('userData') !== '') {
        this.idNumber = JSON.parse(this.cookieService.get('userData')).idNumber;
      }
    }

    this.router.events
      .pipe(
        filter((event: NavigationEvent) => {
          return (event instanceof NavigationStart);
        })
      )
      .subscribe((event: NavigationStart) => {

        setTimeout(() => {
          if (event.url === '/register') {
            $('.navlinks').hide();
            this.showNavButtons(globalThis.innerWidth);
          } else {
            $('.navlinks').show();
          }
        }, 200);

        if (this.isFirstLoad) {
          this.isFirstLoad = false;
          return;
        }

        if (event.url.startsWith('/security-question')) {
          this.idle.stop();
        } else if (this.userAuthService.getAccessToken()) {
          this.reset();
        } else {
          this.idle.stop();
        }

      });

    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        const finalUrl = e.urlAfterRedirects || e.url;
        const sanitizedPath = finalUrl ? finalUrl.split('?')[0].split('#')[0] : '';

        if (sanitizedPath?.startsWith('/hl-registration')) {
          sessionStorage.setItem('lastPublicRoute', finalUrl);
        }

        if (sanitizedPath?.startsWith('/portal')) {
          sessionStorage.setItem('lastValidRoute', sanitizedPath);
        }

        if (this.env.appInsights.isEnable) {
          if (this.cookieService.get('submissionId') === '') {
            const isSecure = window.location.origin.startsWith('https');
            this.cookieService.delete('submissionId', '/');
            this.cookieService.set('submissionId', Guid.create().toString(), undefined, '/', undefined, isSecure, 'Lax');
          }
          
          const userId = this.cookieService.get('userId');
         this.appInsights.trackPageView({
            uri: globalThis.location.href.split('#')[0],
            properties: { SubmissionId: this.cookieService.get('submissionId'), UserId: userId }
          });
          console.log('End Navigation');
            if(!globalThis.location.hash){
              this.trackPageViews();
            }
        }
        }

    });
    
    this.setTimeout();
    this.userInactive.subscribe( );
  }

  trackPageViews() {
    const trackingService = (window as any).trackingService;
    console.log('trackingservice', trackingService);
    console.log('trackingservice href', globalThis.location.href);
    if (trackingService) {
      trackingService.trackPageViews(environment.trackingId);
    } else {
      setTimeout(() => {
        
        this.trackPageViews(); 
      }, 100);
    }
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3000);
  }

  @HostListener('window:resize', [])
  public onResize() {
    if (location.pathname === '/register') {
      this.showNavButtons(globalThis.innerWidth);
    }
  }


  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
  }

  private showNavButtons(width: number) {
    if (width > 767) {
      $('.navlinks').hide();
    } else {
      $('.navlinks').show();
    }
  }


  /**
   * Diagnostics for the Sanlam Online hand-over: what the page was opened with and what the OAuth
   * library decided. Logs parameter names, booleans and event types only - never token values or
   * personal data.
   */
  private traceTokenPickup(): void {
    const hash = new URLSearchParams(globalThis.location.hash.replace(/^#/, ''));
    console.log('[SOL] Page opened:', {
      path: globalThis.location.pathname,
      hashParams: Array.from(hash.keys()),
      queryParams: Array.from(new URLSearchParams(globalThis.location.search).keys()),
      b2cError: hash.get('error'),
      b2cErrorDescription: hash.get('error_description'),
      policy: this.b2cConfig.currentKind(),
      storedAccessToken: !!this.oauthService.getAccessToken(),
      storedTokenStillValid: this.oauthService.hasValidAccessToken()
    });

    const traced = ['token_received', 'token_error', 'invalid_nonce_in_state', 'token_validation_error',
      'discovery_document_loaded', 'discovery_document_load_error', 'jwks_load_error', 'logout', 'session_terminated'];
    this.oauthService.events.subscribe(event => {
      if (traced.includes(event.type)) {
        const reason = (event as any).reason;
        console.log('[SOL] OAuth event:', event.type, reason ? String(reason?.message ?? reason).slice(0, 200) : '');
      }
    });
  }

  ngOnInit() {
    this.traceTokenPickup();

    // Initialize OAuth implicit flow
    this.userAuthService.oauthReady = this.oauthService.tryLoginImplicitFlow()
      .catch(err => {
        console.error('[SOL] tryLoginImplicitFlow failed:', err);
        if (this.env.appInsights.isEnable) {
          this.appInsights.trackEvent({ name: 'SanlamOnlineIntegrationError' }, {
            Stage: 'TokenPickup',
            Error: err?.message || err?.type || String(err),
            Page: globalThis.location.pathname,
            SubmissionId: this.cookieService.get('submissionId')
          });
        }
        return false;
      })
      .then(tokenReceived => {
        console.log('[SOL] tryLoginImplicitFlow finished:', {
          tokenReceivedFromUrl: tokenReceived,
          hasValidSession: this.oauthService.hasValidAccessToken()
        });
        return tokenReceived;
      });

    // Phased rollout: pick the SOL or SCS B2C for this entry.
    this.userAuthService.oauthReady.then(() => this.b2cConfig.refreshForEntry(this.oauthService));

    //tracking script
    const script = this.renderer.createElement('script');
    script.type = 'module';
    script.innerHTML = `import * as tl from "` + environment.trackingUrl + `"
    tl.trackEvent('` + environment.trackingId + `',["span"]);
    globalThis.trackingService = tl;`;
    this.renderer.appendChild(document.head, script);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'optimize.activate'}); // Google optimize event

    // sets an idle timeout of 3 seconds, for testing purposes.
    this.idle.setIdle(this.env.sessionTimeOut);
    // sets a timeout period of 3 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    let lastHiddenAt: number | null = null;
    let wasIdlingWhenHidden = false;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        lastHiddenAt = Date.now();
         wasIdlingWhenHidden = this.modalService.hasOpenModals();
        return;
      }
      if (document.visibilityState === 'visible' && this.userAuthService.getAccessToken()) {
        const hiddenDurationMs = lastHiddenAt ? Date.now() - lastHiddenAt : Infinity;
        const idleThresholdMs = this.env.sessionTimeOut * 1000;
        if (!wasIdlingWhenHidden && hiddenDurationMs < idleThresholdMs) {
          this.modalService.dismissAll();
          this.reset();
        }
        lastHiddenAt = null;
      }
    });
    this.idle.onIdleEnd.subscribe(() => {
      // NOTE: do NOT call this.idle.stop() here. onIdleEnd fires from inside
      // idle.watch() itself, and stop() wipes the fresh expiry watch() just
      // set, corrupting the next idle cycle so it fires almost immediately.
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      
    });

    this.idle.onTimeout.subscribe(() => {
      this.reportMfaAbandonedIfNeeded();
      if (!this.userAuthService.getAccessToken()) {
        this.idle.stop();
        return;
      }
      this.modalService.dismissAll();
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      this.logout(() => {
        this.idle.stop();
      });
    });

    this.idle.onIdleStart.subscribe(() => {
      if (!this.userAuthService.getAccessToken()) {
        return;
      }
      this.idleState = 'You\'ve session gone expire!';
      this.sessionTimeoutModalRef = this.modalService.open(this.logoutModel, this.modalOptions);
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Your session will time out in ' + countdown + ' seconds.';
      // console.log(this.idleState);
      if (this.modalService.hasOpenModals()) {
        this.idle.clearInterrupts();
      }
    });

    // sets the ping interval to 3 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    if (this.userAuthService.hasValidSession()) {
      this.reset();
      this.processCampaignUserDcQuote();
      this.processLoginDebtCounsellingLms();
    } else {
      this.idle.stop();
    }

    this.checkPWA();

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.track || params.Track)) {
        this.notificationClickTrack = params.track || params.Track;
        this.pushNotificationTracking(this.notificationClickTrack);
      }
      
      if (params && params.error) {
        this.router.navigate([], {
          queryParams: { error: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
    });
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  hideChildModal(): void {
    this.modalService.dismissAll();
  }

  stay() {
    if (this.sessionTimeoutModalRef) {
      this.sessionTimeoutModalRef.close();
      this.sessionTimeoutModalRef = null;
    }
    this.reset();
  }

  private reportMfaAbandonedIfNeeded() {
    if (this.mfaSessionService.isOtpOutstanding()) {
      this.mfaSessionService.clearOtpOutstanding();
      this.otpService.mfaSessionExpired().subscribe({ error: () => { } });
    }
  }

  logout(callback?: () => void) {
    if (callback) {
      callback();
    }
    this.reportMfaAbandonedIfNeeded();
    this.modalService.dismissAll();
    (window as any).fcWidget.destroy();
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId','/');
    localStorage.removeItem('intermediaryDataCode');
    localStorage.removeItem('intermediaryDataCode');
    localStorage.removeItem('imagebase64Data');
    this.userAuthService.logOut();
  }

  private configureAzureAd() {
    this.b2cConfig.apply(this.oauthService);
  }

  private processCampaignUserDcQuote(): void {
    const isCampaignUserDcQuote = sessionStorage.getItem('isCampaignUserDcQuote');
    if (isCampaignUserDcQuote === 'true') {
      this.dcQuoteService.processUserForDcQuoteIfNeeded();
      sessionStorage.removeItem('isCampaignUserDcQuote');
    }
  }

  checkPWA() {
    window.addEventListener('appinstalled', (eve) => {
      this.cookieService.delete('isPwaActive', '/');
      this.cookieService.set('isPwaActive', '1', undefined, '/', undefined, true, 'Lax');

      this.appInsights.trackEvent({ name: 'PwaLog' }, {
        Type: 'customLog',
        Name: 'pwa',
        Value: 'appinstalled',
        Page: globalThis.location.pathname,
        UserId: this.cookieService.get('userId'),
        SubmissionId: this.cookieService.get('submissionId')
      });
    });

    window.addEventListener('beforeinstallprompt', (eve) => {
      this.cookieService.delete('isPwaActive', '/');
      this.cookieService.set('isPwaActive', '0', undefined, '/', undefined, true, 'Lax');
    });
  }

  pushNotificationTracking(value: any) {
    this.appInsights.trackEvent({ name: 'NotificationLog' }, {
      Type: 'customLog',
      Name: 'Notification',
      Value: value,
      Page: globalThis.location.pathname,
      UserId: this.cookieService.get('userId'),
      SubmissionId: this.cookieService.get('submissionId')
    });
  }

  private processLoginDebtCounsellingLms(): void {
    const isNewLoginSession = this.computeIsNewLoginSession();
    this.profileService.sendLoginSignal();

    this.profileService.userProfile().subscribe({
      next: (data: any) => {
        if (data?.cellNumberVerifiedByUser || !data?.phoneNumber) {
          this.fireLoginDebtCounsellingLms(isNewLoginSession);
        } else {
          this.stashPendingLoginProcessing(isNewLoginSession);
        }
      },
      error: () => this.fireLoginDebtCounsellingLms(isNewLoginSession)
    });
  }

  private computeIsNewLoginSession(): boolean {
    if (sessionStorage.getItem('landingVisited')) {
      return false;
    }
    sessionStorage.setItem('landingVisited', 'visited');
    return true;
  }

  private stashPendingLoginProcessing(isNewLoginSession: boolean): void {
    if (sessionStorage.getItem('pendingLoginProcessing') === null) {
      sessionStorage.setItem('pendingLoginProcessing', String(isNewLoginSession));
    }
  }

  private fireLoginDebtCounsellingLms(isNewLoginSession: boolean): void {
    this.profileService.processLoginDebtCounsellingLms(isNewLoginSession).subscribe({
      next: (data: any) => {
        const isLeadSent = sessionStorage.getItem('IsLeadSent');
        const phoneNumber = data.phoneNumber;
        const returnXPostbackBaseUrl = this.env.returnXPostbackBaseUrl || (this.env as any).returnXPostbackBaseUrl;
        if (isLeadSent !== 'true' && returnXPostbackBaseUrl && phoneNumber) {
          fetch(`${returnXPostbackBaseUrl}?phone=${encodeURIComponent(phoneNumber)}`);
        }
      }
    });
  }
}
